import '@ff/material-controls/core/interfaces';

const maskMatrix = {
    phone0: '+ 000-000-0000000',
    phone1: '+ 0 000-000-0000000',
    phone2: '+ 00 000-000-0000000',
    phone3: '+ 000 000-000-0000000',
    phonePlusOnly: '+0000000000000000',
    smsCode: '000000',
    cardNumber: '0000 0000 0000 00000000',
    beneficiaryPhone: '+000-000-000000 0000',
    separator: 'separator.2',
};

/**
 * Generated bundle index. Do not edit.
 */

export { maskMatrix };
